import attributeSets from './page/attributeSets/th';
import attributeKeys from './page/attributeKeys/th';
import limitProduct from './page/limitProduct/th';
import banner from './page/banner/en';
import categories from './page/categories/th';
import login from './page/login/th';
import products from './page/products/th';
import searchSynonims from './page/searchSynonims/th';
import users from './page/users/th';
import productLabels from './page/productLabels/th';
import twofactor from './page/twofactor/th';
import modalMediaLibrary from './components/modalMediaLibrary/th';
import manageFilter from './components/manageFilter/th';
import global from './global/th';
import register from './page/register/th';

export default {
	page: {
		attributeSets,
		attributeKeys,
		banner,
		categories,
		login,
		products,
		searchSynonims,
		users,
		productLabels,
		limitProduct,
		register,
		twofactor,
	},
	components: {
		modalMediaLibrary,
		manageFilter,
	},
	global,
};
